export default __webpack_public_path__ + "static/media/help.6ae17002.svg";